import { useEffect } from 'react';
import { toast } from 'react-toastify';

const Aviso = ({ titulo, estado }) => {
  useEffect(() => {
    if (estado) {
      toast.success(`${titulo} was updated correctly!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } else {
      toast.error(`${titulo} could not be Updated!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  }, [titulo, estado]);

  return null;
};

export default Aviso;
